import {createAction, props} from '@ngrx/store';
import {Author} from '../models/author.model';


export const loadAllAuthors = createAction('[Course Page] Load All Authors');

export const authorsLoaded = createAction(
  "[Course Page] All Authors Loaded",
  props<{authors: Author[]}>()
);

export const upsertAuthor = createAction(
  "[Add Author Dialog] Add New Author",
  props<{author:Author}>()
);

export const archiveAuthor = createAction(
  "[Choose Existing Authors Dialog] Archive Author",
  props<{authorId:string}>()
);


